// extracted by mini-css-extract-plugin
export default {"searchInput":"Search_searchInput__g3mg6","withoutEnterButton":"Search_withoutEnterButton__6pOJU","searchByOption":"Search_searchByOption__ESI0V"};